export default "__VITE_ASSET__kzqPZN$8__"